import type { Location } from "@sitescene/types";

import { useMemo } from "react";

import { getLocationZoneSensorIdSets } from "@/features/events/utils/filter-valid-ids";
import { useGetLocations } from "@/hooks/useLocations";

/** Stable fallback so derived ID sets don't change every render while loading. */
const NO_LOCATIONS: Location[] = [];

/** Derived ID sets from the org location tree (for filter validation / URL sync). */
export function useLocationZoneSensorIdSets() {
	const { locationIds, sensorIds, zoneIds } = useOrgLocationTree();
	return { locationIds, sensorIds, zoneIds };
}

/**
 * Canonical org location tree (locations → zones → sensors).
 * React Query is the single source of truth — no reducer mirror.
 */
export function useOrgLocationTree() {
	const {
		isLoadingLocations,
		isLocationsError,
		isLocationsSuccess,
		locationsData = NO_LOCATIONS,
		locationsError,
		refetchLocations,
	} = useGetLocations({ includeZonesAndSensors: true });

	const idSets = useMemo(
		() => getLocationZoneSensorIdSets(locationsData),
		[locationsData],
	);

	return {
		isLoadingLocations,
		isLocationsError,
		isLocationsSuccess,
		locations: locationsData,
		locationsError,
		refetchLocations,
		...idSets,
	};
}
